import { Grid, Typography } from '@mui/material';
import MFSelectField from '../../lib/formik/SelectField';
import { ProceedSaveLater, SubHeading } from '../investors/components';
import { MFTextField } from '../../lib/formik';
import { Formik, validateYupSchema, yupToFormErrors } from 'formik';
import { Applicant } from '../../redux-store/types/api-types';
import {
  DLCLMasters,
  grossAnnualMasters,
  investorTypeMasters,
  PEPsMasters,
  REtypeMaster,
  reTypeValidationDate,
  USER_ROLES,
  YES_NO_MASTER,
} from '../../utils/constant';
import { DatePicker } from '../../lib/formik/DatePicker';
import React, { useEffect, useState } from 'react';
import {
  applicationComparison,
  clearclIdField,
  cleardpIdField,
  currencyConversion,
  getclIdField,
  getdpIdField,
  isCDSL,
  dlclIdFieldMandatory,
  removeSingleQuote,
  saveForLater,
  ifPushToXalt,
  isDprFieldApplicable,
  checkValidationBasedOnDate,
  shouldShowRBICategory,
} from '../../utils/utilityFunctions';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { updateApplication } from '../../redux-store/actions/application';
import { NonIndividualContributorValidationSchema } from '../../utils/schema';
import { useSnackbar } from 'notistack';
import UseRadioGroup from '../../lib/formik/Radio';
import MFCheckbox from '../../lib/formik/Checkbox';
import { isNotNPODeclaration, isNPODeclaration } from '../../utils/declaration';
import { useFeatureToggles } from '../../utils/useDataMdms';

const contributorObject: Partial<Applicant> = {
  name: '',
  cityOfIncorporation: '',
  ckycNo: '',
  investorType: '',
  dateOfBirth: '',
  panNo: '',
  grossAnnualIncome: '> 1 CRORE',
  netWorth: '',
  politicallyExposedPersonStatus: '',
  dlclId: dlclIdFieldMandatory() ? '' : 'none',
  boiOrAop: '',
  darpanRegistrationNo: '',
  isNotNpo: false,
  isNpo: false,
  isCorporateEntity: '',
  reType: '',
  reTypeOthers: '',
  RBIRegNo: '',
  rbiRegulatedEntity: '',
};

export type Values = {
  saveType: string;
  modeOfHolding: string;
  applicants: Partial<Applicant>[];
  isAccreditedInvestor: boolean;
};

const initialValues: Values = {
  modeOfHolding: 'single',
  applicants: [contributorObject],
  saveType: 'save and proceed',
  isAccreditedInvestor: false,
};

export default function ContributorDetails(): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);
  const [contributorValues, setContributorValues] = useState(initialValues);
  const history = useHistory();
  const dispatch = useDispatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { toggler } = useFeatureToggles();
  useEffect(() => {
    try {
      const { applicants = [] } = application || {};
      setContributorValues({
        ...contributorValues,
        isAccreditedInvestor: application?.isAccreditedInvestor || false,
        applicants: applicants.length
          ? applicants.map((applicant) => {
              return {
                ...applicant,
                grossAnnualIncome: applicant.grossAnnualIncome
                  ? applicant.grossAnnualIncome
                  : '> 1 CRORE',
                dlclId: applicant.dlclId ? applicant.dlclId : dlclIdFieldMandatory() ? '' : 'none',
                darpanRegistrationNo: applicant.darpanRegistrationNo || '',
                isNpo: applicant.isNpo ? applicant.isNpo : false,
                isNotNpo: applicant.isNotNpo ? applicant.isNotNpo : false,
                isCorporateEntity: applicant.isCorporateEntity || '',
                reType:
                  checkValidationBasedOnDate(application?.createdAt || '', reTypeValidationDate) &&
                  shouldShowRBICategory(applicant.rbiRegulatedEntity || '')
                    ? applicant?.reType || ''
                    : '',
                // reTypeOthers: OthersOptionForRE(applicant.reType || '')
                //   ? applicant.reTypeOthers || ''
                //   : '',
                RBIRegNo:
                  checkValidationBasedOnDate(application?.createdAt || '', reTypeValidationDate) &&
                  shouldShowRBICategory(applicant.rbiRegulatedEntity || '') &&
                  applicant.reType
                    ? applicant.RBIRegNo || ''
                    : '',
                rbiRegulatedEntity: checkValidationBasedOnDate(
                  application?.createdAt || '',
                  reTypeValidationDate
                )
                  ? applicant.rbiRegulatedEntity
                  : '',
              };
            })
          : [contributorObject],
      });
    } catch (e) {
      console.error((e as Error).message);
    }
  }, [application]);

  const handleApplicant = async (values: Values) => {
    const { saveType, applicants = [], isAccreditedInvestor } = values;
    const { id, currentStep, banks = [] } = application || {};
    // const isAllBanksPennyChecked = banks.length
    //   ? banks.every((bank) => bank.pennydropCheck)
    //   : false;
    // const contributorDetailsFieldsCheck = application?.applicants
    //   .map((applicant, index) => {
    //     return applicants.map((_applicant, ind) => {
    //       if (index === ind) {
    //         const { investorType } = _applicant;
    //         if (investorType !== applicant.investorType) {
    //           return 'true';
    //         }
    //         return 'false';
    //       }
    //       return 'false';
    //     });
    //   })
    //   .flat();
    const checkApplication = applicationComparison(
      {
        ...application,
        applicants: application?.applicants
          .map((applicant, index) => ({
            ...applicant,
            name: removeSingleQuote(applicant.name),
            cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
          }))
          ?.sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
      },
      {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...application!,
        banks:
          values.applicants[0].name?.split("'").join('').trim() ===
          application?.applicants[0].name?.split("'").join('').trim()
            ? banks
            : banks.map((bank) => ({
                ...bank,
                pennydropCheck: false,
                pennydropVerified: false,
              })),
        applicants: values.applicants
          .map((applicant, index) => ({
            ...applicant,
            name: removeSingleQuote(applicant.name),
            cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
            clId: clearclIdField(applicant.dlclId || '') ? '' : applicant.clId,
            dpId: cleardpIdField(applicant.dlclId || '') ? '' : applicant?.dpId?.toUpperCase(),
            isCorporateEntity:
              investorTypeMasters[applicant.investorType || ''] === investorTypeMasters.corporate &&
              checkValidationBasedOnDate(
                application?.createdAt || '',
                toggler.dateFeatureToggles?.npo_validation_date
              )
                ? applicant.isCorporateEntity
                : '',
            reType:
              checkValidationBasedOnDate(application?.createdAt || '', reTypeValidationDate) &&
              shouldShowRBICategory(values.applicants[index].rbiRegulatedEntity || '')
                ? applicants[index].reType || ''
                : '',
            // reTypeOthers:
            //   checkValidationBasedOnDate(application?.createdAt || '', reTypeValidationDate) &&
            //   OthersOptionForRE(applicants[index].reType || '')
            //     ? applicants[index].reTypeOthers || ''
            //     : '',
            RBIRegNo:
              checkValidationBasedOnDate(application?.createdAt || '', reTypeValidationDate) &&
              applicants[index].reType &&
              shouldShowRBICategory(values.applicants[index].rbiRegulatedEntity || '')
                ? applicants[index].RBIRegNo || ''
                : '',
            rbiRegulatedEntity: checkValidationBasedOnDate(
              application?.createdAt || '',
              reTypeValidationDate
            )
              ? applicant.rbiRegulatedEntity
              : '',
            accreditationCertificateNumber:
              isAccreditedInvestor &&
              checkValidationBasedOnDate(
                application?.createdAt || '',
                toggler.dateFeatureToggles.accredidation_Validation_Date
              )
                ? applicant.accreditationCertificateNumber || ''
                : '',
            accreditationValidFrom:
              isAccreditedInvestor &&
              checkValidationBasedOnDate(
                application?.createdAt || '',
                toggler.dateFeatureToggles.accredidation_Validation_Date
              )
                ? applicant.accreditationValidFrom || null
                : null,
            accreditationValidTo:
              isAccreditedInvestor &&
              checkValidationBasedOnDate(
                application?.createdAt || '',
                toggler.dateFeatureToggles.accredidation_Validation_Date
              )
                ? applicant.accreditationValidTo || null
                : null,
          }))
          .sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
        modeOfHolding: 'single',
        isAccreditedInvestor: isAccreditedInvestor,
        currentStep: !!currentStep && currentStep > 1 ? currentStep : Number(currentStep) + 1,
      }
    );

    if (id && !checkApplication) {
      await dispatch(
        updateApplication({
          body: {
            ...application,
            banks:
              values.applicants[0].name?.split("'").join('').trim() ===
              application?.applicants[0].name?.split("'").join('').trim()
                ? banks
                : banks.map((bank) => ({
                    ...bank,
                    pennydropCheck: false,
                    pennydropVerified: false,
                  })),
            applicants: values.applicants.map((applicant, index) => ({
              ...applicant,
              name: removeSingleQuote(applicant.name),
              cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
              clId: clearclIdField(applicant.dlclId || '') ? '' : applicant.clId,
              dpId: cleardpIdField(applicant.dlclId || '') ? '' : applicant?.dpId?.toUpperCase(),
              boiOrAop:
                ifPushToXalt(application?.pushDataTo || '') &&
                investorTypeMasters[applicants[index]?.investorType || ''] ===
                  investorTypeMasters.boi_or_aop
                  ? applicants[index].boiOrAop
                  : '',
              isCorporateEntity:
                investorTypeMasters[applicant.investorType || ''] ===
                  investorTypeMasters.corporate &&
                checkValidationBasedOnDate(
                  application?.createdAt || '',
                  toggler.dateFeatureToggles?.npo_validation_date
                )
                  ? applicant.isCorporateEntity
                  : '',
              darpanRegistrationNo:
                isDprFieldApplicable(
                  applicant.investorType || '',
                  applicant.isCorporateEntity || ''
                ) &&
                checkValidationBasedOnDate(
                  application?.createdAt || '',
                  toggler.dateFeatureToggles?.npo_validation_date
                )
                  ? applicant.darpanRegistrationNo
                  : '',
              reType:
                checkValidationBasedOnDate(application?.createdAt || '', reTypeValidationDate) &&
                shouldShowRBICategory(values.applicants[index].rbiRegulatedEntity || '')
                  ? applicants[index].reType || ''
                  : '',
              // reTypeOthers:
              //   checkValidationBasedOnDate(application?.createdAt || '', reTypeValidationDate) &&
              //   OthersOptionForRE(applicants[index].reType || '')
              //     ? applicants[index].reTypeOthers || ''
              //     : '',
              RBIRegNo:
                checkValidationBasedOnDate(application?.createdAt || '', reTypeValidationDate) &&
                applicants[index].reType &&
                shouldShowRBICategory(values.applicants[index].rbiRegulatedEntity || '')
                  ? applicants[index].RBIRegNo || ''
                  : '',
              rbiRegulatedEntity: checkValidationBasedOnDate(
                application?.createdAt || '',
                reTypeValidationDate
              )
                ? applicant.rbiRegulatedEntity
                : '',
              isNpo:
                isDprFieldApplicable(
                  applicant.investorType || '',
                  applicant.isCorporateEntity || ''
                ) &&
                checkValidationBasedOnDate(
                  application?.createdAt || '',
                  toggler.dateFeatureToggles?.npo_validation_date
                )
                  ? applicant.isNpo
                  : false,
              isNotNpo:
                isDprFieldApplicable(
                  applicant.investorType || '',
                  applicant.isCorporateEntity || ''
                ) &&
                checkValidationBasedOnDate(
                  application?.createdAt || '',
                  toggler.dateFeatureToggles?.npo_validation_date
                )
                  ? applicant.isNotNpo
                  : false,
              accreditationCertificateNumber:
                isAccreditedInvestor &&
                checkValidationBasedOnDate(
                  application?.createdAt || '',
                  toggler.dateFeatureToggles.accredidation_Validation_Date
                )
                  ? applicant.accreditationCertificateNumber || ''
                  : '',
              accreditationValidFrom:
                isAccreditedInvestor &&
                checkValidationBasedOnDate(
                  application?.createdAt || '',
                  toggler.dateFeatureToggles.accredidation_Validation_Date
                )
                  ? applicant.accreditationValidFrom || null
                  : null,
              accreditationValidTo:
                isAccreditedInvestor &&
                checkValidationBasedOnDate(
                  application?.createdAt || '',
                  toggler.dateFeatureToggles.accredidation_Validation_Date
                )
                  ? applicant.accreditationValidTo || null
                  : null,
            })),
            modeOfHolding: 'single',
            isAccreditedInvestor: isAccreditedInvestor,
            currentStep: 2,
            // !!currentStep && currentStep > 1
            //   ? (values.applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //       isAllBanksPennyChecked) ||
            //     (contributorDetailsFieldsCheck as unknown as string[])?.includes('true')
            //     ? 2
            //     : currentStep
            //   : (values.applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //       isAllBanksPennyChecked) ||
            //     (contributorDetailsFieldsCheck as unknown as string[])?.includes('true')
            //   ? 2
            //   : Number(currentStep) + 1,
          },
          applicationId: id,
          ...(saveType !== 'save and proceed' && {
            toastMessage: '',
          }),
        })
      );
    }
  };

  const handleSubmit = async (values: Values) => {
    try {
      setLoading(true);
      const { id, applicant1ReferenceId = '', applicationNumber } = application || {};
      const { saveType } = values;
      await handleApplicant(values);
      saveType === 'save and proceed'
        ? history.push('contact-details', { id, applicant1ReferenceId })
        : history.push(saveForLater(role, id, applicant1ReferenceId));
      if (saveType !== 'save and proceed') {
        enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
      }
      //history.push(`document-details`, { applicationType: 'non_individual' });
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    }
  };

  return (
    <Formik
      initialValues={contributorValues}
      validate={(values: Values) => {
        try {
          validateYupSchema(
            values,
            NonIndividualContributorValidationSchema(
              application?.createdAt || '',
              ifPushToXalt(application?.pushDataTo || ''),
              application?.createdAt || '',
              toggler
            ),
            true,
            values
          );
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      onSubmit={handleSubmit}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues, setFieldValue }) => (
        <>
          <Grid
            container
            rowSpacing={1}
            //columnSpacing={5}
            sx={{
              width: '100%',
              ml: 0,
              '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
            }}
            component="form"
            noValidate
            onSubmit={handleSubmit}>
            {checkValidationBasedOnDate(
              application?.createdAt || '',
              toggler.dateFeatureToggles.accredidation_Validation_Date
            ) && (
              <Grid item xs={12}>
                <MFCheckbox
                  name="isAccreditedInvestor"
                  label="I am an accredited investor"
                  checked={values.isAccreditedInvestor}
                  onChange={({ target: { checked } }) => {
                    setFieldValue('isAccreditedInvestor', checked);
                    if (!checked) {
                      values.applicants.forEach((_, index) => {
                        setFieldValue(`applicants.${index}.accreditationCertificateNumber`, '');
                        setFieldValue(`applicants.${index}.accreditationValidFrom`, null);
                        setFieldValue(`applicants.${index}.accreditationValidTo`, null);
                      });
                    }
                  }}
                />
              </Grid>
            )}
            {values.applicants.map((applicant, index) => (
              <React.Fragment key={index}>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.name`}
                    label="Name of Entity *"
                    placeholder="Enter Name of Entity"
                    disabled={applicant.dataFetchedFromKRA || false}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <DatePicker
                    label={'Date of Registration/Incorporation *'}
                    inputLabelStyles={{
                      transform: 'unset',
                      fontSize: 14,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)',
                    }}
                    placeholder={'DD/MM/YYYY'}
                    name={`applicants.${index}.dateOfBirth`}
                    disabled={applicant.dataFetchedFromKRA || false}
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.cityOfIncorporation`}
                    label="Place of Registration/Incorporation *"
                    placeholder="Enter Place of Registration/Incorporation"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.ckycNo`}
                    label="CKYC No./CKYC Acknowledge No./KIN No "
                    placeholder="Enter CKYC No./CKYC Acknowledge No./KIN No"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.investorType`}
                    label="Investor Type *"
                    items={Object.keys(investorTypeMasters).map((investor) => ({
                      key: investorTypeMasters[investor],
                      value: investor,
                    }))}
                  />
                </Grid>
                {/* {ifPushToXalt(application?.pushDataTo || '') &&
                  investorTypeMasters[values?.applicants[index]?.investorType || ''] ===
                    investorTypeMasters.boi_or_aop && (
                    <Grid item xs={12} sm={6}>
                      <MFSelectField
                        name={`applicants.${index}.boiOrAop`}
                        label="AOP or BOI *"
                        items={Object.keys(AOI_BOI_MASTER).map((investor) => ({
                          key: AOI_BOI_MASTER[investor],
                          value: investor,
                        }))}
                      />
                    </Grid>
                  )} */}
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.panNo`}
                    label="PAN *"
                    placeholder="Enter PAN"
                    disabled={true}
                  />
                </Grid>
                {values.isAccreditedInvestor &&
                  checkValidationBasedOnDate(
                    application?.createdAt || '',
                    toggler.dateFeatureToggles.accredidation_Validation_Date
                  ) && (
                    <>
                      <Grid item xs={12} sm={6}>
                        <MFTextField
                          name={`applicants.${index}.accreditationCertificateNumber`}
                          label={`Accreditation Certificate Number *`}
                          placeholder="Enter Certificate Number"
                          // inputProps={{ maxLength: 12 }}
                          disabled={
                            [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role) || false
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <DatePicker
                          label={`Accreditation Certificate Start Date *`}
                          inputLabelStyles={{
                            transform: 'unset',
                            fontSize: 14,
                            fontWeight: 500,
                            color: 'rgba(0,0,0,0.7)',
                          }}
                          placeholder="DD/MM/YYYY"
                          name={`applicants.${index}.accreditationValidFrom`}
                          disabled={
                            [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role) || false
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <DatePicker
                          label={`Accreditation Certificate End Date *`}
                          inputLabelStyles={{
                            transform: 'unset',
                            fontSize: 14,
                            fontWeight: 500,
                            color: 'rgba(0,0,0,0.7)',
                          }}
                          placeholder="DD/MM/YYYY"
                          name={`applicants.${index}.accreditationValidTo`}
                          maxDate={null}
                          disabled={
                            [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role) || false
                          }
                        />
                      </Grid>
                    </>
                  )}
                {investorTypeMasters[applicant.investorType || ''] ===
                  investorTypeMasters.corporate &&
                  checkValidationBasedOnDate(
                    application?.createdAt || '',
                    toggler.dateFeatureToggles?.npo_validation_date
                  ) && (
                    <Grid item xs={12} sm={6}>
                      <UseRadioGroup
                        formLabel="Section 8 Companies"
                        name={`applicants.${index}.isCorporateEntity`}
                        items={Object.keys(YES_NO_MASTER).map((item) => ({
                          label: YES_NO_MASTER[item],
                          value: item,
                        }))}
                      />
                    </Grid>
                  )}
                  {checkValidationBasedOnDate(application?.createdAt || '', reTypeValidationDate) && (
                  <>
                    {' '}
                    <Grid item xs={12} sm={6}>
                      <UseRadioGroup
                        formLabel="Are you a RBI Regulated Entity? *"
                        name={`applicants.${index}.rbiRegulatedEntity`}
                        items={Object.keys(YES_NO_MASTER).map((item) => ({
                          label: YES_NO_MASTER[item],
                          value: item,
                        }))}
                      />
                    </Grid>
                    {shouldShowRBICategory(values.applicants[index].rbiRegulatedEntity || '') && (
                      <>
                        {' '}
                        <Grid item xs={12} sm={6}>
                          <MFSelectField
                            name={`applicants.${index}.reType`}
                            label="RE Types: *"
                            items={Object.keys(REtypeMaster).map((types) => ({
                              key: REtypeMaster[types],
                              value: types,
                            }))}
                          />
                        </Grid>
                        {values.applicants[index].reType && (
                          <Grid item xs={12} sm={6}>
                            <MFTextField
                              name={`applicants.${index}.RBIRegNo`}
                              label="RBI Registration Number"
                              placeholder={`Enter RBI Registration Number`}
                            />
                          </Grid>
                        )}
                        {/* {OthersOptionForRE(values.applicants[index].reType || '') && (
                      <Grid item xs={12} sm={6}>
                        <MFTextField
                          name={`applicants.${index}.reTypeOthers`}
                          label="Please Specify Other Type *"
                          placeholder={`Enter Other RE Type`}
                        />
                      </Grid>
                    )} */}
                      </>
                    )}
                  </>
                )}
                {isDprFieldApplicable(
                  values.applicants[index].investorType || '',
                  values.applicants[index].isCorporateEntity || ''
                ) &&
                  checkValidationBasedOnDate(
                    application?.createdAt || '',
                    toggler.dateFeatureToggles?.npo_validation_date
                  ) && (
                    <>
                      <Grid item xs={12}>
                        <MFCheckbox
                          name={`applicants.${index}.isNpo`}
                          label={isNPODeclaration}
                          sx={{
                            fontSize: 14,
                            fontWeight: 500,
                            color: 'rgba(0,0,0,0.7)',
                            alignItems: 'flex-start',
                            '.MuiTypography-root': {
                              fontSize: 15,
                              fontWeight: 500,
                            },
                          }}
                          checked={values.applicants[index].isNpo}
                          onChange={() => {
                            const current = values.applicants[index].isNpo;
                            setFieldValue(`applicants.${index}.isNpo`, !current);
                            setFieldValue(`applicants.${index}.isNotNpo`, false);
                          }}
                          // disabled={values.applicants[index].isNotNpo}
                        />
                      </Grid>
                      {
                        <Grid item xs={12} sm={6}>
                          <MFTextField
                            name={`applicants.${index}.darpanRegistrationNo`}
                            label={
                              values.applicants[index].isNpo
                                ? `Darpan Portal Registration Number *`
                                : 'Darpan Portal Registration Number'
                            }
                            placeholder={'Enter Darpan portal Registration Number'}
                          />
                        </Grid>
                      }
                      <Grid item xs={12}>
                        <Typography
                          variant="body1"
                          sx={{ fontWeight: 600, textAlign: 'center', my: 1 }}>
                          OR
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <MFCheckbox
                          name={`applicants.${index}.isNotNpo`}
                          label={isNotNPODeclaration}
                          sx={{
                            fontSize: 14,
                            fontWeight: 500,
                            color: 'rgba(0,0,0,0.7)',
                            alignItems: 'flex-start',
                            '.MuiTypography-root': {
                              fontSize: 15,
                              fontWeight: 500,
                            },
                          }}
                          //checked={values.applicants[index].isNotNpo}
                          checked={Boolean(values.applicants[index].isNotNpo)}
                          onChange={() => {
                            const current = values.applicants[index].isNotNpo;
                            setFieldValue(`applicants.${index}.isNotNpo`, !current);
                            setFieldValue(`applicants.${index}.isNpo`, false);
                          }}
                          // disabled={values.applicants[index].isNpo}
                        />
                      </Grid>
                    </>
                  )}
                <SubHeading
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}>
                  Other Details
                </SubHeading>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.grossAnnualIncome`}
                    label="Gross Annual Income"
                    items={grossAnnualMasters.map((grossIncome) => ({
                      key: grossIncome,
                      value: grossIncome,
                    }))}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.netWorth`}
                    label="~ Net Worth As on Current Date *"
                    placeholder="Enter Net Worth As on Current Date"
                  />
                  {values.applicants[index].netWorth &&
                    !isNaN(Number(values.applicants[index].netWorth)) && (
                      <Typography sx={{ fontSize: 13 }}>
                        {currencyConversion(values.applicants[index].netWorth)}
                      </Typography>
                    )}
                </Grid>
                {/* <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.politicallyExposedPersonStatus`}
                    label="Politically Exposed Person (PEP) Status"
                    items={PEPsMasters.map((pep) => ({ key: pep, value: pep }))}
                    disabled={true}
                  />
                </Grid> */}
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.dlclId`}
                    label={`Demat Account Details (for allotment of units) *`}
                    items={Object.keys(DLCLMasters)
                      .filter((item) => item !== 'none')
                      .map((Id) => ({
                        key: DLCLMasters[Id],
                        value: Id,
                      }))}
                  />
                </Grid>
                {getdpIdField(values.applicants[index].dlclId || '') && (
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.dpId`}
                      label={`${
                        isCDSL(values.applicants[index].dlclId || '') ? 'DPCL ID' : 'DP ID'
                      } *`}
                      placeholder={`Enter ${
                        isCDSL(values.applicants[index].dlclId || '') ? 'DPCL ID' : 'DP ID'
                      }`}
                      inputProps={{ style: { textTransform: 'uppercase' } }}
                    />
                  </Grid>
                )}
                {getclIdField(values.applicants[index].dlclId || '') && (
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.clId`}
                      label="CL ID *"
                      placeholder="Enter CL ID"
                    />
                  </Grid>
                )}
              </React.Fragment>
            ))}
            <ProceedSaveLater
              saveLater={() => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant) => ({
                    ...applicant,
                  })),
                  saveType: 'save for later',
                });
              }}
              saveAndProceed={() => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant) => ({
                    ...applicant,
                  })),
                  saveType: 'save and proceed',
                });
              }}
              loader={loading}
              clickedButton={values.saveType}
            />
          </Grid>
        </>
      )}
    </Formik>
  );
}
